// extracted by mini-css-extract-plugin
module.exports = {"title":"title-4-kk3","tooltip":"tooltip-3eJpp","tooltip_arrow":"tooltip_arrow-2kKoo","popper":"popper-2TjrG"};